import { render, staticRenderFns } from "./grid-box.vue?vue&type=template&id=ae7f6502"
import script from "./grid-box.vue?vue&type=script&lang=js"
export * from "./grid-box.vue?vue&type=script&lang=js"
import style0 from "./grid-box.vue?vue&type=style&index=0&id=ae7f6502&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports